import React from 'react'
import ReactSelect from 'react-select';
import selectStyles from '../../../../ui/selectStyles.js';


const options = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
];



export default function SexSelect(props) {
    const inputId = `field-${props.name}`;

    return (
        <div className="Select">
            <label className="TextField--label" htmlFor={inputId}>{props.label}</label>
            <div className={`Select--container${props.error ? " is-error" : ""}`}>
                <ReactSelect
                    inputId={inputId}
                    options={options}
                    value={props.selectSexData}
                    onChange={props.handleSelectChange}
                    styles={selectStyles}
                    placeholder="Select Gender"
                />
            </div>
            {props.error && <p className="TextField--error">{props.errorMessage}</p>}
        </div>
    )
}
